import { Component } from '@angular/core';

import { NavigationService } from '@shared/services/navigation/navigation.service';
import { DialogRef } from '@ui/dialog/dialog-ref';

@Component({
    selector: 'shop-cart-max-products-error-modal',
    templateUrl: './shop-cart-max-products-error-modal.component.html',
    styleUrls: ['./shop-cart-max-products-error-modal.component.scss'],
})
export class ShopCartMaxProductsErrorModalComponent {
    constructor(private readonly modalRef: DialogRef, private readonly navigationService: NavigationService) {}

    /**
     * Función para ir a la cesta
     */
    public goToShopcart(): void {
        this.navigationService.goToShopcart(false);
        this.modalRef.close();
    }
}
